import React from 'react';
import { statusStyle } from '../lib/status';

export function StatusBadge({ status, size = 'md', testid }) {
  const s = statusStyle(status);
  const pad = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  return (
    <span
      data-testid={testid || `status-badge-${(status || '').toLowerCase().replace(/\s+/g, '-')}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold whitespace-nowrap ${pad}`}
      style={{ color: s.text, backgroundColor: s.bg, border: `1px solid ${s.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.text }} />
      {status}
    </span>
  );
}
